import React, { useEffect, useState } from 'react';
import { faAngleLeft, faEdit } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Col, Row } from 'reactstrap';

//Componentes
import MainCard from '../../../../../components/MainCard';
import TextField from '../../../../../components/TextField';
import moment from 'moment';

//API
import unidadeMonetaria_api from '../../../../../api/unidadeMonetaria_api';

//Helpers
import { objCampo, validarCampos } from '../../../../../helpers/ValidadorDeCampos';
import { showMessage } from '../../../../../helpers/message';
import mascaras from '../../../../../helpers/mascaras';
import { getSessionCookie } from '../../../../../helpers/cookies';

//Context
import { useAuth } from '../../../../../context/auth';


function initialStateUnidadeMonetaria(secretaria_id) {
    const dataInicioVigencia = new Date();
    const dataFimVigencia = new Date();
    dataInicioVigencia.setMonth(dataFimVigencia.getMonth() - 1);

    return {
        id: 0,
        identificacao: "",
        valor: "0,00",
        inicioVigencia: moment(dataInicioVigencia).format("YYYY-MM-DD"),
        fimVigencia: moment(dataFimVigencia).format("YYYY-MM-DD"),
        secretaria_Id: secretaria_id
    }
}

function CadastroUnidadeMonetaria({ id = null, handleVoltar, editavel = false }) {
    //Dados de autenticação
    const session = getSessionCookie();

    //state para Criar / Editar unidade Monetária
    const [unidadeMonetaria, setUnidadeMonetaria] = useState(initialStateUnidadeMonetaria(session.secretaria_Id));

    //State de controle dos campos de erro
    const [errors, setErrors] = useState({});

    const { setLoading } = useAuth();

    const loadUnidadeMonetariaItem = (id) => {
        if (id != null) {
            setLoading(true)
            unidadeMonetaria_api.getItem(id)
                .then(response => {
                    response.data.inicioVigencia = moment(response.data.inicioVigencia).format("YYYY-MM-DD");
                    response.data.fimVigencia = moment(response.data.fimVigencia).format("YYYY-MM-DD");
                    response.data.valor = response.data.valor.toFixed(2).toString();

                    setUnidadeMonetaria(response.data);
                }).catch(err => showMessage("Aviso", err.message, "error", null))
                .finally(() => setLoading(false));
        }
    }

    useEffect(() => {
        loadUnidadeMonetariaItem(id);
    }, []);

    //Estado de controle dos campos obrigatorios 
    const [campos, setCampos] = useState([
        objCampo({ name: "identificacao", required: true }),
        objCampo({ name: "valor", required: true })
    ])

    const onChange = (e) => {
        const { name, value } = e.target;
        const _unidadeMonetaria = {
            ...unidadeMonetaria,
            [name]: value
        };

        //Validando erros no campo especifico para checar em tempo de digitação se ele possui algum erro
        const _campos = campos.filter(campo => campo.name === name);
        const fieldError = validarCampos(_unidadeMonetaria, _campos);

        const _errors = { ...errors };
        delete _errors[name];
        if (fieldError[1].length === 0)
            setErrors({ ..._errors });
        else
            setErrors({ ..._errors, ...fieldError[0] });

        setUnidadeMonetaria(_unidadeMonetaria);
    }

    const onSubmit = () => {
        //Realizando a validação dos campos obrigatorios
        const _errors = validarCampos(unidadeMonetaria, campos);
        setErrors(_errors[0]);

        if (_errors[1].length > 0)
            return true;

        const _unidadeMonetaria = { ...unidadeMonetaria }
        _unidadeMonetaria.valor = _unidadeMonetaria.valor.replace(",", ".");

        if (unidadeMonetaria.id) {
            setLoading(true);
            unidadeMonetaria_api.put(_unidadeMonetaria)
                .then(response => {
                    showMessage("Aviso", "Operação realizada com sucesso", "success", handleVoltar);
                })
                .catch(err => showMessage("Aviso", err.message, "error", null))
                .finally(() => setLoading(false))
        } else {
            setLoading(true);
            unidadeMonetaria_api.post(_unidadeMonetaria)
                .then(response => {
                    showMessage("Aviso", "Operação realizada com sucesso", "success", handleVoltar);
                })
                .catch(err => showMessage("Aviso", err.message, "error", null))
                .finally(() => setLoading(false))
        }
    }

    return <>
        <Button
            onClick={handleVoltar}
            className='px-4'>
            <FontAwesomeIcon icon={faAngleLeft} className='me-2' /> Voltar
        </Button>
        <MainCard>
            <h4 style={{ color: "#666" }}>Unidade Monetária</h4>
            <Row>
                <Col md={12} lg={8}>
                    <TextField
                        label={"* Identificação"}
                        name={"identificacao"}
                        type={"text"}
                        maxLength={30}
                        value={unidadeMonetaria.identificacao}
                        onChange={onChange}
                        invalid={!!errors.identificacao}
                        disabled={!editavel}
                    />
                </Col>
                <Col md={12} lg={4}>
                    <TextField
                        label={"* Valor"}
                        name={"valor"}
                        mask={mascaras.floatMask}
                        type={"text"}
                        value={unidadeMonetaria.valor}
                        onChange={onChange}
                        invalid={!!errors.valor}
                        disabled={!editavel}
                    />
                </Col>
                <Col md={12} lg={3}>
                    <TextField
                        label={"* Inicio Vigência"}
                        name={"inicioVigencia"}
                        type={"date"}
                        value={unidadeMonetaria.inicioVigencia}
                        onChange={onChange}
                        disabled={!editavel}
                    />
                </Col>
                <Col md={12} lg={3}>
                    <TextField
                        label={"* Fim Vigência"}
                        name={"fimVigencia"}
                        type={"date"}
                        value={unidadeMonetaria.fimVigencia}
                        onChange={onChange}
                        disabled={!editavel}
                    />
                </Col>

                <Col md="12" lg="12" className={`d-flex align-items-center justify-content-center mt-4 ${editavel ? "" : "d-none"}`}>
                    <Button
                        className='px-4'
                        color={unidadeMonetaria.id ? 'warning text-white' : 'success'}
                        onClick={onSubmit}>{unidadeMonetaria.id ? <><FontAwesomeIcon icon={faEdit} /> Atualizar</> : "+ Cadastrar"}
                    </Button>
                </Col>
            </Row>
        </MainCard>
    </>;
}

export default CadastroUnidadeMonetaria;